import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8068c092"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.homeClickHandler && _ctx.homeClickHandler(...args)))
    }, "📃bucket"),
    (!_ctx.IsLoggedIn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/login"
        }, {
          default: _withCtx(() => [
            _createTextVNode("로그인")
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(_ctx.nickname), 1),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoutHandler && _ctx.logoutHandler(...args)))
          }, "로그아웃")
        ]))
  ]))
}